// extracted by mini-css-extract-plugin
module.exports = {"ul":"Tags_ul__104aG","skin_colorBox":"Tags_skin_colorBox__2qN2N","tag_linkbox":"Tags_tag_linkbox__2bUqZ","industry_linkbox":"Tags_industry_linkbox__3sIug"};